import { ANIMATIONS } from '../app.config';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Media {

  constructor(context) {
    this.context = context;
    ANIMATIONS && this.init();
  }

  initAnimations() {
    this.items.forEach(el => {
      switch (el.type) {
        case 'fullscale':
          this.fullscaleAnimation(el.items)
          break;
        case 'midscale':
          this.midscaleAnimation(el.items)
          break;
      }
    })
  }

  fullscaleAnimation(items) {
    items.forEach(item => {
      gsap.fromTo(item, {
        'will-change': 'transform',
        scale: 0.7,
        y: '50px'
      }, {
        scale: 1,
        y: '0',
        scrollTrigger: {
          trigger: item,
          start: 'top 95%',
          end: 'top 40%',
          scrub: 6,
        }
      });
    })
  }

  midscaleAnimation(items) {
    items.forEach(item => {
      gsap.fromTo(item, {
        'will-change': 'transform',
        scale: 0.3,
        y: '-25%'
      }, {
        scale: 1,
        y: '0',
        scrollTrigger: {
          trigger: item,
          start: 'top 95%',
          end: 'top 40%',
          scrub: 6,
        }
      });
    })
  }

  init() {
    const elements = Array.from(this.context.querySelectorAll('[data-animate-media]'));
    const fullAnimation = elements.filter(x => x.dataset.animateMedia === 'fullscale');
    const verticalAnimation = elements.filter(x => x.dataset.animateMedia === 'midscale');
    this.items = [{
      type: 'fullscale',
      items: fullAnimation ? fullAnimation : []
    },{
      type: 'midscale',
      items: verticalAnimation ? verticalAnimation : []
    }]

    this.initAnimations();
  }
}
